import { Dayjs } from "dayjs";

import { IPlace, Iterable } from "types";
import { WEEKDAYS } from "constants/constants";

export const availableForDate = (date: Dayjs, place: Iterable<IPlace>) => {
  const currentWeekday = WEEKDAYS[date.day()];
  const timetable = place.work_hours.timetable;

  if (timetable !== null) {
    return timetable[currentWeekday.toLowerCase()] !== null;
  }

  return false;
};
